import styled from 'styled-components'

export const VoucherUsageReportContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
